<template>
  <div>
    <div class="surveyBoxContainer">
      <h5>
        Q{{item.order}} {{item.question}} {{item.essential == 'Y' ? '' : '(선택)'}} 
      </h5>
      <div v-for="(option, index) in item.options" :key="index" class="flex surveyCheckBox">
        <input type="radio" :id="linearId(index)" :value="option.idx" v-model="selected" :disabled="!isOngoing" />
        <label :for="linearId(index)">{{option.data}}</label>
      </div>
    </div>
  </div>
</template>

<script>
import {STATUS} from '@/data/survey'

export default {
  name: 'Linear',
  props:{
    status: null,
    item: null
  },
  data(){
    return{
      isOngoing: false,
      selected: 0 // Option Idx
    }
  },
  mounted(){
    this.init();
  },
  watch:{
    selected(selected){
      this.item.answer.data = selected
    }
  },
  methods:{
    linearId(index){
      return 'linear' + '_' + this.item.order + '_' + index
    },
    init(){
      switch(this.status){
        case STATUS.ONGOING:
          this.isOngoing = true
          break
        default:
          this.isOngoing = false
          break
      }

      const selectedOptionIdx = (Number)(this.item.answer.data)
      const options = (this.item.options)

      for(var i = 0; i < options.length; i++){
        if(options[i].idx == selectedOptionIdx){
          this.selected = options[i].idx
          break
        }
      }
    }
  }
}
</script>